import { render } from "./ProjectPledgeContent.vue?vue&type=template&id=4759a466"
import script from "./ProjectPledgeContent.vue?vue&type=script&lang=js"
export * from "./ProjectPledgeContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__